import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

export default function OrderDetail({ row, isPurchaseOrder }) {
  return (
    <Box sx={{ minWidth: "900px", maxWidth: 1000 }}>
      <TableContainer>
        <Table size="small">
          <TableHead
            sx={{
              "& tr th": {
                background: theme => theme.palette.primary.lighter,
                paddingLeft: "8px",
                color: theme => theme.palette.primary.darker,
              },
            }}
          >
            <TableRow>
              <TableCell>Product</TableCell>
              <TableCell>publisher</TableCell>
              <TableCell>Received Date</TableCell>
              <TableCell>Requested Quantity</TableCell>
              {isPurchaseOrder && (
                <>
                  <TableCell>Received Quantity</TableCell>
                  <TableCell>Excess Quantity</TableCell>
                </>
              )}
            </TableRow>
          </TableHead>
          <TableBody>
            {row.orderDetails?.map(item => (
              <TableRow key={row.id}>
                <TableCell>
                  <Typography variant="subtitle2">
                  {item.productName || "-"}
                  </Typography>
                </TableCell>
                <TableCell>
                  {item.publisherName === "null" ? "-" : item.publisherName}
                </TableCell>
                <TableCell>{item.receivedDate || "-"}</TableCell>
                <TableCell>{item.quantity ?? "-"}</TableCell>
                {isPurchaseOrder && (
                  <>
                    <TableCell>{item.receivedQuantity ?? "-"}</TableCell>
                    <TableCell>{item.excessQuantity ?? "-"}</TableCell>
                  </>
                )}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
